import React, { useState, useRef, useEffect, useMemo } from 'react';
import ClientService from '../../Services/client.service.js';
import HamburgerMenu from '../../Components/HamburgerMenu/HamburgerMenu.jsx'; // Adjust the import path as necessary
import './SubAccountants.css';
import employess from '../../assests/images/office.png'; // Update with the correct path
import UserService from '../../Services/user.service.js';
import CustomDeleteConfirmationModal from '../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal.js';
import SubAccountantService from '../../Services/subAccountant.service.js';
import { useNavigate } from 'react-router-dom';
// import ChatService from '../../Services/chat.service';
import employesGroupIcon from "../../assests/images/employesGroup.png";
import { useTranslation } from 'react-i18next';
import { HashLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import Header from '../../Components/Header/Header.js';
import editIcon from "../../assests/images/edit.png";
import cancelIcon from "../../assests/images/cancel.png";
import loadingAnimation from "../../assests/images/Animation.gif";
import deleteIcon from "../../assests/images/deleteicon.png";
import PuffLoader from "react-spinners/PuffLoader";
import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails.jsx';
import { beautifyNumber } from '../../Utils/FormatNumber.js';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AutocompleteSelect from '../../Components/Widgets/AutocompleteSelect/AutocompleteSelect.jsx';
import SubAccountantsDataGrid from '../../Components/SubAccountants/SubAccountantsDataGrid.jsx';
import subAccountantsIcon from "../../assests/images/Main/subAccountants.svg";
import { Checkbox, FormControlLabel } from '@mui/material';
import { validateEmail, validatePhoneNumber } from '../../Utils/helpers.js';
import SubAccountantFormModal from '../../Components/SubAccountants/SubAccountantFormModal/SubAccountantFormModal.jsx';
import SubAccountantRestrictionsViewModal from '../../Components/SubAccountants/SubAccountantRestrictionsViewModal.jsx';
import { ClientHeaderProvider } from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/ClientHeaderContext.js';
import AccountantCards from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/AccountantCards.jsx';
import PermissionService from '../../Services/permission.service.js';
const SubAccountant = () => {
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const [user, setUser] = useState();
  const [token, setToken] = useState();
  const [isUserDataFetched, setIsUserDataFetched] = useState(false);
  const [subAccountants, setSubAccountants] = useState([]);
  const [subAccountantsForClient, setSubAccountantsForClient] = useState([]);
  const [subAccountantsCount, setSubAccountantsCount] = useState([]);
  const [subAccountantsCountForClient, setSubAccountantsCountForClient] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortOrder, setSortOrder] = useState('asc'); // 'asc' or 'desc'
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isNewSubAccountant, setIsNewSubAccountant] = useState(false);
  const [selectedSubAccountant, setSelectedSubAccountant] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const popupContentRef = useRef(null);
  const [direction, setDirection] = useState('rtl'); // Default to 'rtl'
  const [isSubAccountantForClient, setIsSubAccountantForClient] = useState(false); // New state
  
  // Permissions state - using hardcoded permission since it's already in DB
  const availablePermissions = [
    { permissionId: 500, name: 'CantSeeCollectionPage', type: 'SubAccountant' }
  ];
  const [subAccountantPermissions, setSubAccountantPermissions] = useState([]);
  const [allSubAccountantsPermissions, setAllSubAccountantsPermissions] = useState({}); // Store permissions for all subAccountants
  const [allSubAccountantsRestrictions, setAllSubAccountantsRestrictions] = useState({}); // restriction keys per subAccountant (global scope)
  const [pendingPermissionChanges, setPendingPermissionChanges] = useState([]); // Track permission changes to apply on save
  const [restrictionsClientsList, setRestrictionsClientsList] = useState([]);
  const [restrictionsClientsLoading, setRestrictionsClientsLoading] = useState(false);
  const [restrictionsViewModal, setRestrictionsViewModal] = useState({ open: false, subAccountant: null });

  const allSubAccountantFieldsFilled = !isNewSubAccountant ||
    (isNewSubAccountant &&
      selectedSubAccountant &&
      selectedSubAccountant.subAccountantId &&
      selectedSubAccountant.name &&
      selectedSubAccountant.password &&
      validateEmail(selectedSubAccountant.email) && // Validate email
      validatePhoneNumber(selectedSubAccountant.phoneNumber));

  useEffect(() => {
    // Update direction based on the current language
    if (i18n.language === 'he' || i18n.language === 'ar') {
      setDirection('rtl');
    } else {
      setDirection('ltr');
    }
  }, [i18n.language]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSort = () => {
    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
  };

  const handleViewButtonClick = async (subAccountant, isForClient = false) => {
    setSelectedSubAccountant(subAccountant);
    setIsPopupOpen(true);
    setIsNewSubAccountant(false);
    setIsEditMode(true);
    setPendingPermissionChanges([]);

    if (isForClient) {
      setIsSubAccountantForClient(true);
    } else {
      setIsSubAccountantForClient(false);
    }

    if (subAccountant.subAccountantId && token) {
      await fetchSubAccountantPermissions(subAccountant.subAccountantId);
    }
    if (user?.accountantId && token) {
      setRestrictionsClientsLoading(true);
      try {
        const res = await ClientService.GetMinimalClients(user.accountantId, token, 1, 500, true);
        setRestrictionsClientsList(Array.isArray(res?.clients) ? res.clients : (Array.isArray(res?.Clients) ? res.Clients : (Array.isArray(res) ? res : [])));
      } catch {
        setRestrictionsClientsList([]);
      }
      setRestrictionsClientsLoading(false);
    }
  };



  const handleAddClick = () => {
    setSelectedSubAccountant({});
    setIsNewSubAccountant(true);
    setIsEditMode(false);

    setIsPopupOpen(true);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    setIsEditMode(!isEditMode);
  };

  const handleDelete = async () => {
    // Perform delete operation
    setLoading(true);
    try {
      // Call the DeleteDocument function from DocumentService with the item's id
      const response = await SubAccountantService.DeleteSubAccountant(token, selectedSubAccountant.subAccountantId);
      // const response1 = await ChatService.DeleteChatUser(selectedSubAccountant.subAccountantId);
      if (response.ok) {
        // Handle successful deletion, e.g., by updating your UI
        toast.success(t('deleteSubAccountantSuccess'));
      } else {
        // Handle any errors or display a message
        const errorResponse = await response.json();
        console.error('Error deleting sub-accountant:', errorResponse);
        toast.error(t('deleteSubAccountantError'));
      }
    } catch (error) {
      console.error('Error deleting sub-accountant:', error);
      toast.error(t('deleteSubAccountantError'));
    }
    fetchSubAccountantsData(user.accountantId, token, true);
    setIsModalVisible(false);
    setLoading(false);
  };

  const prepareDelete = () => {
    // Logic for deleting the selected sub-accountant
    setIsPopupOpen(false);
    setIsModalVisible(true)
  };
  const handleClose = () => {
    setIsEditMode(false);
    setIsPopupOpen(false);
    // Reset pending changes when closing without saving
    setPendingPermissionChanges([]);
  };

  // Apply pending permission changes
  const applyPendingPermissionChanges = async (subAccountantId) => {
    if (pendingPermissionChanges.length === 0) return;

    try {
      for (const change of pendingPermissionChanges) {
        if (change.action === 'add') {
          await PermissionService.AssignPermission(
            subAccountantId,
            'SubAccountant',
            change.permissionId,
            token
          );
        } else if (change.action === 'remove') {
          await PermissionService.RemovePermission(
            subAccountantId,
            'SubAccountant',
            change.permissionId,
            token
          );
        }
      }

      // Update the allSubAccountantsPermissions map after all changes
      const updatedPermissions = await PermissionService.GetPermissionsByUserId(
        subAccountantId,
        'SubAccountant',
        token
      );
      setAllSubAccountantsPermissions(prev => ({
        ...prev,
        [subAccountantId]: updatedPermissions || []
      }));

      // Clear pending changes
      setPendingPermissionChanges([]);
    } catch (error) {
      console.error('Error applying permission changes:', error);
      throw error;
    }
  };

  const handleSaveChanges = async () => {
    try {
      setLoading(true);
      const editedItem = {
        SubAccountantId: selectedSubAccountant.subAccountantId,
        AccountantId: selectedSubAccountant.accountantId,
        PhoneNumber: selectedSubAccountant.phoneNumber,
        Email: selectedSubAccountant.email,
        Name: selectedSubAccountant.name,
        PricePerHour: selectedSubAccountant.pricePerHour,
        isSubAccountantForClient: isSubAccountantForClient
      }
      const response = await SubAccountantService.UpdateSubAccountant(token, editedItem);
      if (response.ok) {
        await applyPendingPermissionChanges(selectedSubAccountant.subAccountantId);
        fetchSubAccountantsData(user.accountantId, token, true);
        toast.success(t('updateSubAccountantSuccess'));
      } else {
        const errorText = await response.text();
        console.error(errorText);
        if (errorText === 'SubAccountant Id is similar to accountant Id') {
          toast.error(t('subAccountantIdSimilarError')); // Use a specific translation key
        } else {
          toast.error(t('SubAccountantIdSimilarToTheInputtedNumberError'));
        }
      }
    } catch (error) {
      console.error(error);
      toast.error(t('updateSubAccountantError'));
    }
    setIsEditMode(false);
    setIsPopupOpen(false);
    setLoading(false);
  };


  const handleAddSubAccountant = async () => {
    try {
      setLoading(true);
      const subData = {
        SubAccountantId: selectedSubAccountant.subAccountantId,
        AccountantId: user.accountantId,
        PhoneNumber: selectedSubAccountant.phoneNumber,
        Email: selectedSubAccountant.email,
        Name: selectedSubAccountant.name,
        Password: selectedSubAccountant.password,
        PricePerHour: selectedSubAccountant.pricePerHour,
        isSubAccountantForClient: isSubAccountantForClient
      }
      const response = await UserService.addSubAccountant(subData, token);
      fetchSubAccountantsData(user.accountantId, token, true);
      toast.success(t('updateSubAccountantSuccess'));
    } catch (error) {
      console.error(error);

      if (error?.response?.data?.message === 'SubAccountant Id is similar to accountant Id') {
        toast.error(t('subAccountantIdSimilarError')); // Use a specific translation key
      } else {
        toast.error(t('SubAccountantIdSimilarToTheInputtedNumberError'));
      }
    }
    setIsEditMode(false);
    setIsPopupOpen(false);
    setIsNewSubAccountant(false);
    setSelectedSubAccountant({});
    setLoading(false);
  };

  const [isEditMode, setIsEditMode] = useState(false);


  const isRtl = ['he', 'ar'].includes(i18n.language);


  const fetchSubAccountantsData = async (accountantId, token, isFirstFetch) => {
    try {
      setLoading(true);
      const data = await SubAccountantService.GetSubAccountantByAccountantId(token, accountantId);
      const dataForClients = await SubAccountantService.GetSubAccountantByAccountantIdForClients(token, accountantId);
      setSubAccountantsCount(data.length);

      // Separate lists
      const filteredSubAccountants = data.filter(
        (subAcc) => !dataForClients.some((clientSubAcc) => clientSubAcc.subAccountantId === subAcc.subAccountantId)
      );

      if (isFirstFetch) {
        setSubAccountants(filteredSubAccountants);
        setSubAccountantsForClient(dataForClients);
        // Fetch permissions for all subAccountants
        await fetchAllSubAccountantsPermissions([...filteredSubAccountants, ...dataForClients], token);
        // setSubAccountantsCount(filteredSubAccountants.length);

        // toast.success(t('fetchSubAccountantsDataSuccess'));
      } else {
        setSubAccountants([...subAccountants, ...filteredSubAccountants]);
        setSubAccountantsForClient([...subAccountantsForClient, ...dataForClients]);
      }
    } catch (error) {
      console.error(error);
      toast.error(t('fetchSubAccountantsDataError'));
    }
    setLoading(false);
  };

  // Fetch permissions and restriction keys for all SubAccountants (restrictions in one batch call)
  const fetchAllSubAccountantsPermissions = async (subAccountantsList, token) => {
    try {
      const permissionsMap = {};
      const ids = subAccountantsList
        .map((s) => (s.subAccountantId != null ? String(s.subAccountantId) : ''))
        .filter(Boolean);

      // One batch request for all restrictions (global scope)
      const restrictionsMap = await PermissionService.GetRestrictionsBySubAccountantIds(ids, null, token);

      // Permissions: one call per subAccountant (no batch API)
      const permissionPromises = subAccountantsList.map(async (subAccountant) => {
        const id = subAccountant.subAccountantId != null ? String(subAccountant.subAccountantId) : '';
        try {
          const permissions = await PermissionService.GetPermissionsByUserId(subAccountant.subAccountantId, 'SubAccountant', token);
          permissionsMap[id] = permissions || [];
        } catch (error) {
          console.error(`Error fetching permissions for ${id}:`, error);
          permissionsMap[id] = [];
        }
      });

      await Promise.all(permissionPromises);
      setAllSubAccountantsPermissions(permissionsMap);
      setAllSubAccountantsRestrictions(restrictionsMap);
    } catch (error) {
      console.error('Error fetching all SubAccountants permissions:', error);
    }
  };

  // Fetch permissions for a specific SubAccountant
  const fetchSubAccountantPermissions = async (subAccountantId) => {
    try {
      const permissions = await PermissionService.GetPermissionsByUserId(subAccountantId, 'SubAccountant', token);
      setSubAccountantPermissions(permissions || []);
    } catch (error) {
      console.error('Error fetching SubAccountant permissions:', error);
      setSubAccountantPermissions([]);
    }
  };

  // Handle permission toggle (only tracks changes, doesn't save immediately)
  const handlePermissionToggle = (permissionId) => {
    const hasPermission = subAccountantPermissions.some(p => p.permissionId === permissionId);
    
    if (hasPermission) {
      // Remove from current list
      setSubAccountantPermissions(subAccountantPermissions.filter(p => p.permissionId !== permissionId));
    } else {
      // Add to current list
      const permission = availablePermissions.find(p => p.permissionId === permissionId);
      if (permission) {
        setSubAccountantPermissions([...subAccountantPermissions, {
          permissionId: permission.permissionId,
          permission: permission
        }]);
      }
    }
    
    // Track this change for saving later
    const existingChangeIndex = pendingPermissionChanges.findIndex(
      change => change.permissionId === permissionId
    );
    
    if (existingChangeIndex >= 0) {
      // Toggle existing pending change
      const updatedChanges = [...pendingPermissionChanges];
      updatedChanges[existingChangeIndex].action = 
        updatedChanges[existingChangeIndex].action === 'add' ? 'remove' : 'add';
      setPendingPermissionChanges(updatedChanges);
    } else {
      // Add new pending change
      setPendingPermissionChanges([
        ...pendingPermissionChanges,
        {
          permissionId,
          action: hasPermission ? 'remove' : 'add'
        }
      ]);
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const user = await UserService.getCurrentUser();
        const token = await UserService.getCurrentToken();
        if (user && token) {
          setUser(user);
          setToken(token);
          setIsUserDataFetched(true); // Set true when user data is successfully fetched
          fetchSubAccountantsData(user.accountantId, token, true); // Fetch subAccountants after setting user data
        } else {
          navigate("/login");
        }
      } catch (error) {
        setIsUserDataFetched(false);
        navigate("/login");
      }
    };
    setLoading(false);
    fetchUserData();
  }, []);

  // Load clients list for restrictions modals (edit + view by client)
  useEffect(() => {
    if (!user?.accountantId || !token) return;
    setRestrictionsClientsLoading(true);
    ClientService.GetMinimalClients(user.accountantId, token, 1, 500, true)
      .then((res) => {
        setRestrictionsClientsList(Array.isArray(res?.clients) ? res.clients : (Array.isArray(res?.Clients) ? res.Clients : (Array.isArray(res) ? res : [])));
      })
      .catch(() => setRestrictionsClientsList([]))
      .finally(() => setRestrictionsClientsLoading(false));
  }, [user?.accountantId, token]);

  const handleOverlayClick = () => {
    setIsPopupOpen(false);
  };

  const handleContainerClick = (e) => {
    e.stopPropagation(); // Prevents the overlay's click event from firing when clicking inside the container
  };

  const handleViewRestrictions = (row) => {
    setRestrictionsViewModal({ open: true, subAccountant: row });
  };

  // Filter subAccountants based on search query
  const filteredSubAccountants = useMemo(() => {
    return subAccountants
      .filter(subAccountant =>
        subAccountant.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        subAccountant.subAccountantId.toLowerCase().includes(searchQuery.toLowerCase())
      )
      .sort((a, b) => {
        if (sortOrder === 'asc') {
          return a.name.localeCompare(b.name);
        } else {
          return b.name.localeCompare(a.name);
        }
      });
  }, [subAccountants, searchQuery, sortOrder]);

  const filteredSubAccountantsForClient = useMemo(() => {
    return subAccountantsForClient
      .filter(subAccountant =>
        subAccountant.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        subAccountant.subAccountantId.toLowerCase().includes(searchQuery.toLowerCase())
      )
      .sort((a, b) => {
        if (sortOrder === 'asc') {
          return a.name.localeCompare(b.name);
        } else {
          return b.name.localeCompare(a.name);
        }
      });
  }, [subAccountantsForClient, searchQuery, sortOrder]);

  const headerContextValue = {
    t,
    direction,
    beautifyNumber,
    subAccountantsCount,
    subAccountantsIcon,
    handleAddClick,
    cardType: "subAccountants" 
  };
  
  return (
      <>
        <>
          {/* <div className={`main-title ${direction}`}>{t('OfficeAccountManagers')}</div> */}

          <ClientHeaderProvider value={headerContextValue}>
            <AccountantCards />
          </ClientHeaderProvider>
          
          <div className={`filtersBar ${direction}`} >
            <TextField
              fullWidth
              placeholder={t('SearchAccountManagers')}   
              value={searchQuery}
              onChange={handleSearchChange}
              className="search-bar"
              variant="standard"
              InputProps={{
                disableUnderline: true,
                className: `custom-input-box-sizing ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                sx: {
                  height: '48px',
                  padding: '0 10px',
                  borderRadius: '8px',
                  background: '#F5F5F6',
                  border: '1px solid transparent',
                  '&:focus-within': {
                    border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
                  },
                },
                ...(direction === 'ltr'
                  ? {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton edge="end" style={{ marginRight: '10px' }}>
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }
                  : {
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton edge="start" style={{ marginLeft: '10px' }}>
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }),
              }}
              inputProps={{
                style: {
                  textAlign: direction === 'ltr' ? 'left' : 'right',
                },
              }}
            />

          </div>
          <SubAccountantsDataGrid
            filteredSubAccountants={filteredSubAccountants}
            handleViewButtonClick={(subAccountant) => handleViewButtonClick(subAccountant, false)}
            showHourlyRate={true}
            allSubAccountantsPermissions={allSubAccountantsPermissions}
            allSubAccountantsRestrictions={allSubAccountantsRestrictions}
            onViewRestrictions={handleViewRestrictions}
          />
          <div className={`main-title ${direction}`}>{t('BusinessAccountManagers')}</div>
          <SubAccountantsDataGrid
            filteredSubAccountants={filteredSubAccountantsForClient}
            handleViewButtonClick={(subAccountant) => handleViewButtonClick(subAccountant, true)}
            showHourlyRate={false}
            allSubAccountantsPermissions={allSubAccountantsPermissions}
            allSubAccountantsRestrictions={allSubAccountantsRestrictions}
            onViewRestrictions={handleViewRestrictions}
          />

        </>

        <SubAccountantFormModal
          isOpen={isPopupOpen}
          onClose={handleClose}
          onOverlayClick={handleOverlayClick}
          onContainerClick={handleContainerClick}
          isEditMode={isEditMode}
          isNewSubAccountant={isNewSubAccountant}
          selectedSubAccountant={selectedSubAccountant}
          setSelectedSubAccountant={setSelectedSubAccountant}
          isSubAccountantForClient={isSubAccountantForClient}
          setIsSubAccountantForClient={setIsSubAccountantForClient}
          handleAddSubAccountant={handleAddSubAccountant}
          handleSaveChanges={handleSaveChanges}
          prepareDelete={prepareDelete}
          direction={direction}
          allFieldsFilled={allSubAccountantFieldsFilled}
          availablePermissions={availablePermissions}
          subAccountantPermissions={subAccountantPermissions}
          onPermissionToggle={handlePermissionToggle}
          accountantId={user?.accountantId}
          token={token}
        />
        <SubAccountantRestrictionsViewModal
          open={restrictionsViewModal.open}
          onClose={() => setRestrictionsViewModal({ open: false, subAccountant: null })}
          subAccountantId={restrictionsViewModal.subAccountant?.subAccountantId}
          subAccountantName={restrictionsViewModal.subAccountant?.name}
          token={token}
          clientsList={restrictionsClientsList}
          clientsLoading={restrictionsClientsLoading}
          t={t}
          direction={direction}
          onSaveSuccess={() => fetchSubAccountantsData(user?.accountantId, token, true)}
        />
        <CustomDeleteConfirmationModal
          isVisible={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          onDelete={() => handleDelete(selectedSubAccountant.subAccountantId)}
        />
        <ToastContainer />
        {loading && (
          <div className="loader-container">
            <PuffLoader
              size={100}        // Larger size for better visibility
              loading={loading}
            />
          </div>
        )}
      </>
    
  );
};

export default SubAccountant;